import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Avatar,
  Toolbar,
  Typography,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import React from 'react'

import classes from './IndividualStudent.module.css'
import { blueArrow, editIco, qrcode } from '../../../../../../assets/icons'
import IndividualField from '../../../../../../common/IndividualField/IndividualField'
import IndividualFilter from './IndividualFilter/IndividualFilter'
import { DataTable, DateInput, SelectField } from '../../../../../../components'
import { DashboardHead } from '../../../Dashboard/DashboardPage'
import { urls, baseURL } from '../../../../../../shared/config'
import {
  individualfeesHeadCells,
  individualStudentCells,
} from '../../../../../../shared/data/headCells'
import {
  setLoader,
  setOpenIndividualStudent,
  setSchoolDInfo,
  setStudentID,
} from '../../../../../../redux/globalSlice'
import { useGlobal } from '../../../../../../shared'
import axios from 'axios'
import { toast } from 'react-toastify'
import { uploadImageToS3 } from '../../../../../../shared/config/S3Utils'
import { extractFileName, formatDate } from '../../../../../../shared/utils/constants'
import YearFeesField from '../../../../../../common/YearFees/YearFees'
import { AadharImage } from '../../../../../../components/ImageUploader/ImageUploader'
import { QRCodeDisplay } from '../../School/SchoolRegistration/components/Steps'

const genderOptions = [
  { label: 'Male', value: 'Male' },
  { label: 'Female', value: 'Female' },
]
const monthOptions = [
  { label: 'January', value: 'January' },
  { label: 'February', value: 'February' },
  { label: 'March', value: 'March' },
  { label: 'April', value: 'April' },
  { label: 'May', value: 'May' },
  { label: 'June', value: 'June' },
  { label: 'July', value: 'July' },
  { label: 'August', value: 'August' },
  { label: 'September', value: 'September' },
  { label: 'October', value: 'October' },
  { label: 'November', value: 'November' },
  { label: 'December', value: 'December' },
]
const IndividualStudent = ({
  setUpdate,
  setDetail,
  update,
  customRole,
  userSchoolId,
  detail,
  refetch,
}) => {
  const dispatch = useDispatch()
  const school_fee_method = localStorage.getItem('school_fee_method')

  const studentID = useSelector((state) => state.global.studentID)
  // console.log('--studentID', studentID)
  const [downloadQR, setDownload] = React.useState(false)
  const [editMode, setEditMode] = useState(!!update)
  const [formValues, setFormValues] = useState({})

  const [studentPreview, setStudentPreview] = useState('')
  const [motherPreview, setMotherPreview] = useState('')
  const [fatherPreview, setFatherPreview] = useState('')

  const [studentFile, setStudentFile] = useState('')
  const [motherFile, setMotherFile] = useState('')
  const [fatherFile, setFatherFile] = useState('')
  const [GradeMapId, setGradeMapId] = useState('')
  const [sectionMapID, setSectionMapID] = useState('')
  const handleGradeChange = (selectedOption) => {
    setFormValues((prev) => ({
      ...prev,
      gradeVal: selectedOption, // store the selected grade_id
    }))

    const selectedGrade = gradeList?.find((grade) => grade.grade_id === selectedOption)
    if (selectedGrade) {
      setGradeMapId(selectedGrade.grade_map_id)
    }
  }

  // Updated section handler – no formik
  const handleSectionChange = (selectedOption) => {
    setFormValues((prev) => ({
      ...prev,
      section_id: selectedOption, // store the selected section_id
    }))

    const selectedSection = sectionList?.find((section) => section.section_id === selectedOption)
    if (selectedSection) {
      setSectionMapID(selectedSection.section_map_id)
    }
  }

  const { data: Data } = useGlobal({
    userUrl: `${urls.STUDENT_PROFILE}?student_id=${studentID}`,
  })

  const { data: FeeData } = useGlobal({
    userUrl: `${urls.INDIVIDUAL_STUDENT_FEES}${studentID}&fee_method=${school_fee_method}`,
  })
  const { data: routeData } = useGlobal({
    userUrl: `${urls.ROUTE_GET}${customRole == 'Admin' ? userSchoolId : ''}&page=1&limit=10000`,
  })
  const { data: vanData } = useGlobal({
    userUrl: `${urls.VAN_GET}${customRole == 'Admin' ? userSchoolId : ''}&page=1&limit=10000`,
  })
  const { data: stopData } = useGlobal({
    userUrl: `${urls.STOP_GET}${formValues?.route_id}`,
  })

  const student = Data?.[0] || {}

  // console.log('----student', student)

  const yearlyFeeData = FeeData?.[0]

  // console.log('[---yearlyFeeData', yearlyFeeData)

  const { data: gradeList } = useGlobal({
    userUrl: `${urls.GRADE_LIST}${customRole == 'Admin' ? userSchoolId : ''}`,
  })

  // console.log('-----formik')

  const { data: sectionList } = useGlobal({ userUrl: `${urls.SECTION_LIST}${GradeMapId}` })
  useEffect(() => {
    if (student && Object.keys(student).length > 0) {
      // Helper to convert ISO date string to YYYY-MM-DD for date inputs
      const toDateInputFormat = (isoString) => {
        if (!isoString) return ''
        return isoString.slice(0, 10) // "2025-06-15T00:00:00.000Z" → "2025-06-15"
      }

      setFormValues({
        student_state: student?.student_state || '',
        student_name: student.student_name || '',
        student_gender: student.student_gender || '',
        student_dob: toDateInputFormat(student.student_dob), // ← FIXED: now shows properly in DateInput
        student_grade: student.student_grade || '',
        student_registration_number: student.student_registration_number || '',
        student_section: student.student_section || '',
        student_admission_month: student.student_admission_month || '',
        student_phone_number: student.student_phone_number || student.student_father_contact || '',
        student_alternate_contact_number: student.student_alternate_contact_number || '',
        student_email: student.student_email || '',
        student_van_facility: !!student.student_van_facility,
        van_number: student.van_number || '',
        driver_name: student.driver_name || '',
        student_address: student.student_address || '',
        student_city: student.student_city || '',
        student_pincode: student.student_pincode || '',
        pen_id: student.student_pen_id || '',
        apaar_id: student.student_apaar_id || '',
        student_aadhar_number: student.student_aadhar_number || '',
        aadharFile: '',
        aadharPreview: student.aadhar_url || '',
        aadharUrl: student.aadhar_url || '',
        certificateFile: '',
        certificatePreview: student.birth_certification_url || '',
        certificateUrl: student.birth_certification_url || '',
        tcFile: '',
        tcPreview: student.previous_school_tc_url || '',
        tcUrl: student.previous_school_tc_url || '',
        marksheetFile: '',
        marksheetPreview: student.previous_school_marksheet_url || '',
        marksheetUrl: student.previous_school_marksheet_url || '',
        gradeVal: student?.grade_id,
        section_id: student?.section_id,
        route_id: student?.route_id,
        van_id: student?.van_id,
        transport_start_month: student?.transport_start_month || '',
        transport_end_month: student?.transport_end_month || '',
        stop_id: student?.stop_id || '',
        ps_name: student?.previous_school_name || '',
        ps_city: student?.previous_school_city || '',
        ps_board: student?.previous_school_board || '',
        ps_mob: student?.previous_school_mob || '',
        f_age: student?.father_age || '',
        f_aadhar_no: student?.father_aadhar_no || '',
        p_address: student?.parent_address || '',
        p_address2: student?.parent_address2 || '',
        p_city: student?.parent_city || '',
        p_state: student?.parent_state || '',
        p_pin_code: student?.parent_pin_code || '',
        mother_age: student?.mother_age || '',
        // student_mother_name: student?.mother_name || '',
        mother_aadhar_no: student?.mother_aadhar_no || '',
        student_father_name: student?.student_father_name || '',
        student_mother_name: student?.student_mother_name || '',
        student_state: student?.student_state || '',
        student_caste: student?.student_caste || '',
        father_email: student?.father_email || '',
        student_batch_year: student?.student_batch_year || '',
        student_name: student?.student_name || '',
        student_id: student?.student_id || '',
        student_discount: student?.student_fee_discount || 0,
      })

      setStudentPreview(student.student_avatar || '')
      setMotherPreview(student.mother_image_url || '')
      setFatherPreview(student.father_image_url || '')
      setSectionMapID(student?.section_map_id || 0)
    }
  }, [student])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    if (name === 'student_van_facility') {
      const boolValue = value === 'Yes' || value === 'yes' || value === true
      setFormValues((prev) => ({ ...prev, [name]: boolValue }))
    } else {
      setFormValues((prev) => ({ ...prev, [name]: value }))
    }
  }

  const handleGenderChange = (selected) => {
    const newValue = selected?.value ?? selected?.target?.value ?? selected ?? ''
    setFormValues((prev) => ({ ...prev, student_gender: newValue }))
  }
  const handleTransportChange = (selected) => {
    const newValue = selected?.value ?? selected?.target?.value ?? selected ?? ''
    setFormValues((prev) => ({ ...prev, student_van_facility: newValue }))
  }
  const handleRouteChange = (selected) => {
    const newValue = selected?.value ?? selected?.target?.value ?? selected ?? ''
    setFormValues((prev) => ({ ...prev, route_id: newValue }))
  }
  const handleStopChange = (selected) => {
    const newValue = selected?.value ?? selected?.target?.value ?? selected ?? ''
    setFormValues((prev) => ({ ...prev, stop_id: newValue }))
  }
  const handleVanChange = (selected) => {
    const newValue = selected?.value ?? selected?.target?.value ?? selected ?? ''
    setFormValues((prev) => ({ ...prev, van_id: newValue }))
  }
  const handleStartMonthChange = (selected) => {
    const newValue = selected?.value ?? selected?.target?.value ?? selected ?? ''
    setFormValues((prev) => ({ ...prev, transport_start_month: newValue }))
  }
  const handleEndMonthChange = (selected) => {
    const newValue = selected?.value ?? selected?.target?.value ?? selected ?? ''
    setFormValues((prev) => ({ ...prev, transport_end_month: newValue }))
  }

  const handleFileChange = (type) => (e) => {
    const file = e.target.files?.[0]
    if (!file) return

    const objectUrl = URL.createObjectURL(file)

    if (type === 'student') {
      setStudentFile(file)
      setStudentPreview(objectUrl)
    } else if (type === 'mother') {
      setMotherFile(file)
      setMotherPreview(objectUrl)
    } else if (type === 'father') {
      setFatherFile(file)
      setFatherPreview(objectUrl)
    }
  }

  const validateRequiredFields = () => {
    const missingFields = []

    // Helper function to safely get string value
    const getStringValue = (value) => {
      if (value === null || value === undefined) return ''
      return String(value).trim()
    }

    // Basic Information
    if (!getStringValue(formValues.student_name)) missingFields.push('Student Name')
    if (!getStringValue(formValues.student_registration_number))
      missingFields.push('Registration Number')
    if (!getStringValue(formValues.student_batch_year)) missingFields.push('Batch Year')
    if (!getStringValue(formValues.student_admission_month)) missingFields.push('Admission Month')
    if (!getStringValue(formValues.student_gender)) missingFields.push('Gender')
    if (!getStringValue(formValues.student_dob)) missingFields.push('Date of Birth')
    if (!getStringValue(formValues.student_caste)) missingFields.push('Caste')

    // Contact Information
    if (!getStringValue(formValues.student_phone_number)) {
      missingFields.push('Primary Phone Number')
    } else if (!/^[6-9]\d{9}$/.test(formValues.student_phone_number)) {
      toast.error('Phone number must be 10 digits starting with 6-9')
      return false
    }

    // if (!getStringValue(formValues.student_email)) {
    //   missingFields.push('Email')
    // } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValues.student_email)) {
    //   toast.error('Please enter a valid email address')
    //   return false
    // }

    // Address Information
    if (!getStringValue(formValues.student_address)) missingFields.push('Address')
    if (!getStringValue(formValues.student_city)) missingFields.push('City')
    if (!getStringValue(formValues.student_state)) missingFields.push('State')
    if (!getStringValue(formValues.student_pincode)) {
      missingFields.push('Pincode')
    } else if (!/^\d{6}$/.test(formValues.student_pincode)) {
      toast.error('Pincode must be 6 digits')
      return false
    }

    // Class Information
    if (!formValues.gradeVal && formValues.gradeVal !== 0) missingFields.push('Grade')
    if (!formValues.section_id && formValues.section_id !== 0) missingFields.push('Section')

    // Important Documents
    if (!getStringValue(formValues.pen_id)) missingFields.push('PEN Number')
    if (!getStringValue(formValues.apaar_id)) missingFields.push('Apaar ID')
    if (!getStringValue(formValues.student_aadhar_number)) {
      missingFields.push('Student Aadhar Number')
    } else if (!/^\d{12}$/.test(formValues.student_aadhar_number)) {
      toast.error('Student Aadhar number must be 12 digits')
      return false
    }

    // Birth Certificate validation (file)
    // if (editMode) {
    //   if (!formValues.certificateUrl && !formValues.certificateFile) {
    //     missingFields.push('Birth Certificate')
    //   }
    // } else {
    //   if (!formValues.certificateFile) {
    //     missingFields.push('Birth Certificate')
    //   }
    // }

    // Father's Information
    if (!getStringValue(formValues.student_father_name)) missingFields.push("Father's Name")

    const fatherAge = formValues.f_age
    if (fatherAge === undefined || fatherAge === null || fatherAge === '') {
      missingFields.push("Father's Age")
    } else {
      const age = Number(fatherAge)
      if (isNaN(age) || age < 18 || age > 100) {
        toast.error("Father's age must be between 18 and 100")
        return false
      }
    }

    const fatherAadhar = formValues.f_aadhar_no
    if (fatherAadhar === undefined || fatherAadhar === null || fatherAadhar === '') {
      missingFields.push("Father's Aadhar Number")
    } else if (!/^\d{12}$/.test(String(fatherAadhar))) {
      toast.error("Father's Aadhar number must be 12 digits")
      return false
    }

    // if (!getStringValue(formValues.father_email)) {
    //   missingFields.push("Father's Email")
    // } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValues.father_email)) {
    //   toast.error("Please enter a valid father's email address")
    //   return false
    // }

    if (!getStringValue(formValues.p_address)) missingFields.push("Father's Address")
    if (!getStringValue(formValues.p_city)) missingFields.push("Father's City")
    if (!getStringValue(formValues.p_state)) missingFields.push("Father's State")
    if (!getStringValue(formValues.p_pin_code)) {
      missingFields.push("Father's Pincode")
    } else if (!/^\d{6}$/.test(formValues.p_pin_code)) {
      toast.error("Father's pincode must be 6 digits")
      return false
    }

    // Mother's Information
    if (!getStringValue(formValues.student_mother_name)) missingFields.push("Mother's Name")

    const motherAge = formValues.mother_age
    if (motherAge === undefined || motherAge === null || motherAge === '') {
      missingFields.push("Mother's Age")
    } else {
      const age = Number(motherAge)
      if (isNaN(age) || age < 18 || age > 100) {
        toast.error("Mother's age must be between 18 and 100")
        return false
      }
    }

    const motherAadhar = formValues.mother_aadhar_no
    if (motherAadhar === undefined || motherAadhar === null || motherAadhar === '') {
      missingFields.push("Mother's Aadhar Number")
    } else if (!/^\d{12}$/.test(String(motherAadhar))) {
      toast.error("Mother's Aadhar number must be 12 digits")
      return false
    }

    // Mother's Contact (if you have this field)
    if (formValues.mother_contact !== undefined) {
      if (!getStringValue(formValues.mother_contact)) {
        missingFields.push("Mother's Contact Number")
      } else if (!/^[6-9]\d{9}$/.test(formValues.mother_contact)) {
        toast.error("Mother's contact number must be 10 digits starting with 6-9")
        return false
      }
    }

    // Transport validation (if opted)
    if (formValues.student_van_facility) {
      if (!formValues.route_id && formValues.route_id !== 0) missingFields.push('Route')
      if (!formValues.stop_id && formValues.stop_id !== 0) missingFields.push('Stop')
      if (!formValues.van_id && formValues.van_id !== 0) missingFields.push('Van')
      if (!getStringValue(formValues.transport_start_month))
        missingFields.push('Transport Start Month')
      if (!getStringValue(formValues.transport_end_month)) missingFields.push('Transport End Month')
    }

    // Show missing fields if any
    if (missingFields.length > 0) {
      toast.error(`Please fill required fields: ${missingFields.join(', ')}`)
      return false
    }

    return true
  }
  const handleSave = async () => {
    if (!validateRequiredFields()) {
      return
    }
    dispatch(setLoader(true))
    try {
      const fileUploads = [
        {
          file: studentFile,
          folder: 'student',
          existingUrl: student.student_avatar,
          key: 'student_avatar',
        },
        {
          file: motherFile,
          folder: 'parent', // changed from 'student' — more logical
          existingUrl: student.mother_image_url,
          key: 'mother_image',
        },
        {
          file: fatherFile,
          folder: 'parent',
          existingUrl: student.father_image_url,
          key: 'father_image',
        },
        {
          file: formValues.aadharFile,
          folder: 'document',
          existingUrl: formValues.aadharUrl,
          key: 'aadhar_url',
        },
        {
          file: formValues.certificateFile,
          folder: 'document',
          existingUrl: formValues.certificateUrl,
          key: 'certification_url',
        },
        {
          file: formValues.tcFile,
          folder: 'document',
          existingUrl: formValues.tcUrl,
          key: 'ps_tc_url',
        },
        {
          file: formValues.marksheetFile,
          folder: 'document',
          existingUrl: formValues.marksheetUrl,
          key: 'ps_marksheet_url',
        },
      ]

      const uploadedUrls = {}

      // Upload files in parallel
      await Promise.all(
        fileUploads.map(async ({ file, folder, existingUrl, key }) => {
          if (file) {
            try {
              const uploadedUrl = await uploadImageToS3(file, folder)
              uploadedUrls[key] = uploadedUrl
            } catch (uploadErr) {
              console.error(`Failed to upload ${key}:`, uploadErr)
              uploadedUrls[key] = existingUrl || '' // fallback to existing
              // You can choose to throw or continue — here we continue
            }
          } else {
            uploadedUrls[key] = existingUrl || formValues[key] || ''
          }
        }),
      )
      // ────────────────────────────────────────────────
      // 2. Build final payload – match your Postman example exactly
      // ────────────────────────────────────────────────

      const payload = {
        student_id: studentID,

        // Basic info
        student_name: formValues.student_name || '',
        student_registration_number: formValues.student_registration_number || '',
        student_dob: formValues.student_dob || '',
        student_aadhar_number: formValues.student_aadhar_number || '',
        student_father_name: formValues.student_father_name || '',
        student_father_contact: formValues.student_phone_number || '',
        student_mother_name: formValues.student_mother_name || '',
        student_alternate_contact_number: formValues.student_alternate_contact_number || '',
        student_address: formValues.student_address || '',
        // student_address_two: '', // not in form yet
        student_city: formValues.student_city || '',
        student_state: '', // not in form yet
        student_pincode: formValues.student_pincode || '',
        student_avatar: uploadedUrls.student_avatar,
        student_state: formValues.student_state || '',
        grade_id: formValues.gradeVal || '',
        section_id: formValues.section_id || '',

        // Class / section
        section_map_id: sectionMapID || null,

        // Fees (you didn't show form fields – using defaults or existing)
        student_fee: student.student_fee || 0,
        student_discount: formValues.student_discount ?? student.student_fee_discount ?? 0,
        student_transport_fee: student.student_transport_fee || 0,
        student_misc_fee: student.student_misc_fee || 0,
        student_fee_due_amount: student.student_fee_due_amount || 0,

        // Transport
        student_van_facility: !!formValues.student_van_facility,
        van_id: formValues.van_id || null,
        stop_id: formValues.stop_id || null,
        route_id: formValues.route_id || null,
        transport_start_month: formValues.transport_start_month || '',
        transport_end_month: formValues.transport_end_month || '',

        // Documents
        certification_url: uploadedUrls.certification_url,
        aadhar_url: uploadedUrls.aadhar_url,
        ps_tc_url: uploadedUrls.ps_tc_url,
        ps_marksheet_url: uploadedUrls.ps_marksheet_url,

        // Previous school
        ps_name: formValues.ps_name || '',
        ps_city: formValues.ps_city || '',
        ps_board: formValues.ps_board || '',
        ps_mob: formValues.ps_mob || '',

        // Parent info
        f_age: formValues.f_age || '',
        f_aadhar_no: formValues.f_aadhar_no || '',
        mother_age: formValues.mother_age || '',
        mother_aadhar: formValues.mother_aadhar_no || '',
        p_address: formValues.p_address || '',
        p_address2: formValues.p_address2 || '',
        p_city: formValues.p_city || '',
        p_state: formValues.p_state || '',
        p_pin_code: formValues.p_pin_code || '',

        // Other fields from your example
        student_caste: formValues?.student_caste, // not in form yet
        email: formValues.student_email || '',
        father_email: formValues?.father_email || '', // not in form yet
        apaar_id: formValues.apaar_id || '',
        pen_id: formValues.pen_id || '',
        admission_month: formValues.student_admission_month || '',
        student_batch_year: formValues.student_batch_year || '',
        // student_discount: formValues.student_discount || 0,
        // student_name:formValues?.student_name || "",
      }

      // console.log('---payload', payload)

      // ────────────────────────────────────────────────
      // 3. Send PATCH request
      // ────────────────────────────────────────────────

      const response = await axios.patch(
        `${baseURL}${urls.STUDENT_PATCH || '/students/update'}`,
        payload,
      )

      if ([200, 201, 202].includes(response?.data?.status)) {
        toast.success('Student updated successfully')
        handleClose()
        // Reset file states
        setStudentFile(null)
        setMotherFile(null)
        setFatherFile(null)

        // Reset temporary file objects in formValues
        setFormValues((prev) => ({
          ...prev,
          aadharFile: null,
          certificateFile: null,
          tcFile: null,
          marksheetFile: null,
        }))
        refetch?.()
        setEditMode(false)
      } else {
        toast.error('Update failed')
      }
    } catch (err) {
      console.error('Save error:', err)
      toast.error(err.response?.data?.message || 'Error updating student')
    } finally {
      refetch?.()
      dispatch(setLoader(false))
    }
  }

  const handleCancel = () => {
    const toDateInputFormat = (isoString) => {
      if (!isoString) return ''
      return isoString.slice(0, 10) // "2025-06-15T00:00:00.000Z" → "2025-06-15"
    }
    setFormValues({
      student_name: student.student_name || '',
      student_gender: student.student_gender || '',
      student_dob: toDateInputFormat(student.student_dob) || '',
      student_grade: student.student_grade || '',
      student_registration_number: student.student_registration_number || '',
      student_section: student.student_section || '',
      student_admission_month: student.student_admission_month || '',
      student_phone_number: student.student_phone_number || student.student_father_contact || '',
      student_alternate_contact_number: student.student_alternate_contact_number || '',
      student_email: student.student_email || '',
      student_van_facility: !!student.student_van_facility,
      van_number: student.van_number || '',
      driver_name: student.driver_name || '',
      student_address: student.student_address || '',
      student_city: student.student_city || '',
      student_pincode: student.student_pincode || '',
      pen_id: student.student_pen_id || '',
      apaar_id: student.student_apaar_id || '',
      student_aadhar_number: student.student_aadhar_number || '',
      aadharFile: null,
      aadharPreview: student.aadhar_url || null,
      aadharUrl: student.aadhar_url || null,
      certificateFile: null,
      certificatePreview: student.birth_certification_url || null,
      certificateUrl: student.birth_certification_url || null,
      tcFile: null,
      tcPreview: student.ps_tc_url || null,
      tcUrl: student.ps_tc_url || null,
      marksheetFile: null,
      marksheetPreview: student.previous_school_marksheet_url || null,
      marksheetUrl: student.previous_school_marksheet_url || null,
      gradeVal: student?.grade_id,
      section_id: student?.section_id,
      route_id: student?.route_id,
      van_id: student?.van_id,
      transport_start_month: student?.transport_start_month || '',
      transport_end_month: student?.transport_end_month || '',
      stop_id: student?.stop_id || '',
      ps_name: student?.previous_school_name || '',
      ps_city: student?.previous_school_city || '',
      ps_board: student?.previous_school_board || '',
      ps_mob: student?.previous_school_mob || '',
      f_age: student?.father_age || 0,
      f_aadhar_no: student?.father_aadhar_no || 0,
      p_address: student?.parent_address || 0,
      p_address2: student?.parent_address2 || 0,
      p_city: student?.parent_city || '',
      p_state: student?.parent_state || 0,
      p_pin_code: student?.parent_pin_code || '',
      mother_age: student?.mother_age || 0,
      // student_mother_name: student?.mother_name || 0,
      mother_aadhar_no: student?.mother_aadhar_no || 0,
      student_father_name: student?.student_father_name || '',
      student_mother_name: student?.student_mother_name || '',
      student_state: student.student_state || '',
      student_batch_year: student?.student_batch_year || '',
      student_name: student?.student_name || '',
      student_id: student?.student_id || '',
      student_discount: student?.student_fee_discount || 0,
    })

    setStudentPreview(student.student_avatar || null)
    setMotherPreview(student.mother_image_url || null)
    setFatherPreview(student.father_image_url || null)
    setSectionMapID(student?.section_map_id || 0)

    setStudentFile(null)
    setMotherFile(null)
    setFatherFile(null)

    setEditMode(false)
  }

  const handleClose = () => {
    dispatch(setOpenIndividualStudent(false))
    setUpdate(false)
    setDetail(false)
    dispatch(setSchoolDInfo(null))
    dispatch(setStudentID(''))
  }

  const renderField = (label, name, type = 'text', required) => {

    // console.log('-----name',name,'required',required);
    
    let displayValue = formValues[name] ?? ''
    let disabled = false

    if (name === 'student_van_facility') {
      displayValue = formValues.student_van_facility ? 'Yes' : 'No'
    }
    if (name === 'student_id') {
      disabled = true
    }

    return (
      <IndividualField
        label={label}
        name={name}
        type={type}
        value={displayValue}
        onChange={handleInputChange}
        editMode={editMode}
        required={required}
        disabled={disabled}
      />
    )
  }

  const studentName = formValues.student_name || student.student_name || 'Student'
  const motherName = student.student_mother_name || ''
  const fatherName = student.student_father_name || ''
  const handleDocumentChange = (fieldKey) => (e) => {
    const file = e.target.files?.[0]
    if (!file) return

    const previewUrl = URL.createObjectURL(file)

    setFormValues((prev) => ({
      ...prev,
      [`${fieldKey}File`]: file, // temporary File object
      [`${fieldKey}Preview`]: previewUrl, // temporary preview URL
    }))
  }

  const [selectedValue, setSelectedValue] = React.useState(
    formValues?.student_van_facility === true ? 'Opted' : 'Rejected',
  )
  React.useEffect(() => {
    setSelectedValue(formValues?.student_van_facility ? 'Opted' : 'Rejected')
  }, [formValues?.student_van_facility])

  // console.log('----selectedValue', selectedValue)

  // console.log('---stopData', stopData)

  return (
    <div>
      <Toolbar />

      <div className={classes.parents}>
        <div className="school-toolbar">
          <div style={{ width: '44px', height: '44px' }} className="white-ico">
            <img
              src={blueArrow}
              onClick={handleClose}
              style={{ width: '24px', height: '24px', transform: 'rotate(-90deg)' }}
              className="svg-to-black"
              alt="back"
            />
          </div>
        </div>

        <DashboardHead title="Student Profile" subtitle={`Dashboard / Student / ${studentName}`} />
      </div>

      <div className={classes.top}>
        {/* LEFT COLUMN – Accordions */}
        <div className={classes.lhs}>
          <div className={classes.box}>
            <p className={classes.heading}>Basic Info</p>
            <div className={classes.field}>
              {(update || detail) && renderField('Student Id', 'student_id', 'text', true)}
              {renderField('Student Name.', 'student_name', 'text', true)}
              {renderField('Student Reg. No.', 'student_registration_number', 'text', true)}
              <SelectField
                label={'Gender'}
                required
                options={genderOptions.map((prod) => ({
                  value: prod.value,
                  label: prod.label,
                }))}
                // fees={true}
                width={'auto'}
                name="student_gender"
                value={formValues.student_gender}
                onChange={handleGenderChange}
                readOnly={!editMode}
                isflex={true}
                individualStudent={true}
                row={true}
              />
              {/* {renderField('Date Of Birth', 'student_dob')} */}
              <DateInput
                label={'Date Of Birth'}
                value={formValues.student_dob || ''} // ← actual value
                onChange={(e) => {
                  setFormValues((prev) => ({
                    ...prev,
                    student_dob: e.target.value, // stores YYYY-MM-DD
                  }))
                }}
                row={true}
                disabled={!editMode}
                required
              />
              <div className={classes.textFirlds}>
                {/* {renderField('Grade', 'student_grade')}
                {renderField('Section', 'student_section')} */}
                {renderField('Admission Month', 'student_admission_month', 'text', true)}
                {renderField('Batch Year', 'student_batch_year', 'text', true)}
              </div>
            </div>
          </div>

          <Accordion
            sx={{
              boxShadow: 'none',
              border: 'none',
              padding: '0px',
              // Remove the default divider line (the most common cause of the "line above")
              '&:before': {
                display: 'none',
              },
              // Explicitly remove border from the summary
              '& .MuiAccordionSummary-root': {
                borderBottom: 'none',
                // Optional: reduce padding if it feels too spaced out
                minHeight: '48px',
                '&.Mui-expanded': {
                  minHeight: '48px',
                },
              },
              // '& .MuiAccordionSummary-content': {
              //   margin: '8px 0',
              // },
            }}
          >
            <AccordionSummary
              sx={{
                boxShadow: 'none',
                border: 'none',
                padding: '0px',
              }}
              expandIcon={<ExpandMoreIcon />}
            >
              <p className={classes.heading}>Contact Information</p>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                padding: '0px',
              }}
            >
              <div className={classes.field}>
                {renderField('Phone Number', 'student_phone_number', 'tel', true)}
                {renderField('Emergency Phone', 'student_alternate_contact_number', 'tel')}
                {renderField('Email Address', 'student_email', 'email', false)}
                {renderField('Caste', 'student_caste', 'text', true)}
              </div>
            </AccordionDetails>
          </Accordion>

          <Accordion
            sx={{
              boxShadow: 'none',
              border: 'none',
              padding: '0px',
              // Remove the default divider line (the most common cause of the "line above")
              '&:before': {
                display: 'none',
              },
              // Explicitly remove border from the summary
              '& .MuiAccordionSummary-root': {
                borderBottom: 'none',
                // Optional: reduce padding if it feels too spaced out
                minHeight: '48px',
                '&.Mui-expanded': {
                  minHeight: '48px',
                },
              },
              // '& .MuiAccordionSummary-content': {
              //   margin: '8px 0',
              // },
            }}
          >
            <AccordionSummary
              sx={{
                boxShadow: 'none',
                border: 'none',
                padding: '0px',
              }}
              expandIcon={<ExpandMoreIcon />}
            >
              <p className={classes.heading}>Permanent Address</p>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                padding: '0px',
              }}
            >
              <div className={classes.field}>
                {renderField('Address', 'student_address', 'text', true)}
                {renderField('City', 'student_city', 'text', true)}
                {renderField('State', 'student_state', 'text', true)}
                {renderField('Zipcode', 'student_pincode', 'text', true)}
              </div>
            </AccordionDetails>
          </Accordion>
          <Accordion
            sx={{
              boxShadow: 'none',
              border: 'none',
              padding: '0px',
              // Remove the default divider line (the most common cause of the "line above")
              '&:before': {
                display: 'none',
              },
              // Explicitly remove border from the summary
              '& .MuiAccordionSummary-root': {
                borderBottom: 'none',
                // Optional: reduce padding if it feels too spaced out
                minHeight: '48px',
                '&.Mui-expanded': {
                  minHeight: '48px',
                },
              },
              // '& .MuiAccordionSummary-content': {
              //   margin: '8px 0',
              // },
            }}
          >
            <AccordionSummary
              sx={{
                boxShadow: 'none',
                border: 'none',
                padding: '0px',
              }}
              expandIcon={<ExpandMoreIcon />}
            >
              <p className={classes.heading}>Important Documents</p>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                padding: '0px',
              }}
            >
              <div className={classes.field}>
                {renderField('PEN (Permanent Education Number)', 'pen_id', 'text', false)}
                {renderField('Apaar ID', 'apaar_id', 'text', false)}
                {renderField('Aadhar Number', 'student_aadhar_number', 'text', false)}
                <AadharImage
                  margin={0}
                  individualStudentForm
                  label={'Aadhar File'}
                  fileName={
                    formValues.aadharFile?.name ||
                    (formValues.aadharUrl
                      ? extractFileName(formValues.aadharUrl)
                      : 'No file uploaded')
                  }
                  onFileChange={handleDocumentChange('aadhar')}
                  // required
                />
                <AadharImage
                  margin={0}
                  label={'Birth Certificate'}
                  individualStudentForm
                  fileName={
                    formValues.certificateFile?.name ||
                    (formValues.certificateUrl
                      ? extractFileName(formValues.certificateUrl)
                      : 'No file uploaded')
                  }
                  onFileChange={handleDocumentChange('certificate')}
                  // required
                />
              </div>
            </AccordionDetails>
          </Accordion>
          <Accordion
            sx={{
              boxShadow: 'none',
              border: 'none',
              padding: '0px',
              // Remove the default divider line (the most common cause of the "line above")
              '&:before': {
                display: 'none',
              },
              // Explicitly remove border from the summary
              '& .MuiAccordionSummary-root': {
                borderBottom: 'none',
                // Optional: reduce padding if it feels too spaced out
                minHeight: '48px',
                '&.Mui-expanded': {
                  minHeight: '48px',
                },
              },
              // '& .MuiAccordionSummary-content': {
              //   margin: '8px 0',
              // },
            }}
          >
            <AccordionSummary
              sx={{
                boxShadow: 'none',
                border: 'none',
                padding: '0px',
              }}
              expandIcon={<ExpandMoreIcon />}
            >
              <p className={classes.heading}>Assign Class</p>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                padding: '0px',
              }}
            >
              <div className={classes.field}>
                <SelectField
                  label={'Class'}
                  options={(gradeList || [])?.map((prod) => ({
                    value: prod.grade_id,
                    label: prod.grade,
                  }))}
                  width={'100%'}
                  // required
                  name="gradeVal"
                  value={formValues.gradeVal}
                  onChange={(selectedOption) => handleGradeChange(selectedOption)}
                  subLabel={'Class :'}
                  readOnly={!editMode}
                  isflex={true}
                  individualStudent={true}
                  row={true}
                  required={true}
                />
                <SelectField
                  label={'Section'}
                  options={(sectionList || [])?.map((prod) => ({
                    value: prod.section_id,
                    label: prod.section,
                  }))}
                  width={'100%'}
                  // required
                  name="section"
                  subLabel={'Section :'}
                  value={formValues?.section_id}
                  onChange={(selectedOption) => handleSectionChange(selectedOption)}
                  readOnly={!editMode}
                  isflex={true}
                  individualStudent={true}
                  row={true}
                  required={true}
                />
              </div>
              {/* Fixed Discount Fee Field */}
              <div className={classes.textFirlds}>
                {' '}
                {/* or classes.field if you prefer */}
                <IndividualField
                  label="Discount Fee"
                  name="student_discount"
                  type="number"
                  value={formValues.student_discount ?? ''}
                  onChange={(e) => {
                    const value = e.target.value === '' ? 0 : Number(e.target.value)
                    setFormValues((prev) => ({
                      ...prev,
                      student_discount: value,
                    }))
                  }}
                  editMode={editMode}
                  required={false}
                />
              </div>
            </AccordionDetails>
          </Accordion>
          <Accordion
            sx={{
              boxShadow: 'none',
              border: 'none',
              padding: '0px',
              // Remove the default divider line (the most common cause of the "line above")
              '&:before': {
                display: 'none',
              },
              // Explicitly remove border from the summary
              '& .MuiAccordionSummary-root': {
                borderBottom: 'none',
                // Optional: reduce padding if it feels too spaced out
                minHeight: '48px',
                '&.Mui-expanded': {
                  minHeight: '48px',
                },
              },
              // '& .MuiAccordionSummary-content': {
              //   margin: '8px 0',
              // },
            }}
          >
            <AccordionSummary
              sx={{
                boxShadow: 'none',
                border: 'none',
                padding: '0px',
              }}
              expandIcon={<ExpandMoreIcon />}
            >
              <p className={classes.heading}>Travel / Transport Information</p>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                padding: '0px',
              }}
            >
              <div className={classes.field}>
                <SelectField
                  label={'Transport Facility'}
                  // required
                  options={[
                    {
                      value: true,
                      label: 'Opted',
                    },
                    {
                      value: false,
                      label: 'Refused',
                    },
                  ].map((prod) => ({
                    value: prod.value,
                    label: prod.label,
                  }))}
                  // fees={true}
                  width={'auto'}
                  name="van_facility"
                  value={formValues.student_van_facility}
                  onChange={handleTransportChange}
                  readOnly={!editMode}
                  isflex={true}
                  individualStudent={true}
                  row={true}
                  required={true}
                />
                {selectedValue === 'Opted' && (
                  <>
                    <SelectField
                      label={'Route'}
                      options={(routeData || [])?.map((prod) => ({
                        value: prod.route_id,
                        label: prod.route_name,
                      }))}
                      width={'100%'}
                      required
                      name="route"
                      value={formValues?.route_id}
                      onChange={(selectedOption) => handleRouteChange(selectedOption)}
                      subLabel={''}
                      placeholder={'Select'}
                    />
                    {formValues.route_id && (
                      <SelectField
                        label={'Stop'}
                        options={(stopData || [])?.map((prod) => ({
                          value: prod.stop_id,
                          label: prod.stop_address,
                        }))}
                        width={'100%'}
                        required
                        name="stop"
                        placeholder={'Select'}
                        subLabel={''}
                        value={formValues?.stop_id}
                        onChange={(selectedOption) => handleStopChange(selectedOption)}
                      />
                    )}

                    <SelectField
                      label={'Van'}
                      options={(vanData || [])?.map((prod) => ({
                        value: prod.van_id,
                        label: prod.van_number,
                      }))}
                      width={'100%'}
                      required
                      name="van"
                      placeholder={'Select'}
                      subLabel={''}
                      value={formValues?.van_id}
                      onChange={(selectedOption) => handleVanChange(selectedOption)}
                    />
                    <SelectField
                      label={'Start Month'}
                      required
                      options={(monthOptions || [])?.map((prod) => ({
                        value: prod.value,
                        label: prod.label,
                      }))}
                      width={'100%'}
                      name="transport_start_month"
                      value={formValues?.transport_start_month}
                      onChange={(selectedOption) => handleStartMonthChange(selectedOption)}
                    />
                    <SelectField
                      label={'End Month'}
                      required
                      options={(monthOptions || [])?.map((prod) => ({
                        value: prod.value,
                        label: prod.label,
                      }))}
                      width={'100%'}
                      name="transport_end_month"
                      value={formValues?.transport_end_month}
                      onChange={(selectedOption) => handleEndMonthChange(selectedOption)}
                    />
                    {/* <DateInput value={formik.values.effect_from} label={'With Effect From'} required={true} /> */}
                  </>
                )}
                {/* {renderField('Van Facility', 'student_van_facility')}
                {renderField('Van Number', 'van_number')}
                {renderField('Driver Name', 'driver_name')} */}
              </div>
            </AccordionDetails>
          </Accordion>
          <Accordion
            sx={{
              boxShadow: 'none',
              border: 'none',
              padding: '0px',
              // Remove the default divider line (the most common cause of the "line above")
              '&:before': {
                display: 'none',
              },
              // Explicitly remove border from the summary
              '& .MuiAccordionSummary-root': {
                borderBottom: 'none',
                // Optional: reduce padding if it feels too spaced out
                minHeight: '48px',
                '&.Mui-expanded': {
                  minHeight: '48px',
                },
              },
              // '& .MuiAccordionSummary-content': {
              //   margin: '8px 0',
              // },
            }}
          >
            <AccordionSummary
              sx={{
                boxShadow: 'none',
                border: 'none',
                padding: '0px',
              }}
              expandIcon={<ExpandMoreIcon />}
            >
              <p className={classes.heading}>Previous School Details</p>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                padding: '0px',
              }}
            >
              <div className={classes.field}>
                {renderField('School Name', 'ps_name','text', false)}
                {renderField('School City', 'ps_city','text', false)}
                {renderField('School Board', 'ps_board','text', false)}
                {renderField('School Mobile Number', 'ps_mob', 'tel',false)}
                <AadharImage
                  margin={0}
                  label={'TC'}
                  individualStudentForm
                  fileName={
                    formValues.tcFile?.name ||
                    (formValues.tcUrl ? extractFileName(formValues.tcUrl) : 'No file uploaded')
                  }
                  onFileChange={handleDocumentChange('tc')}
                />
                <AadharImage
                  margin={0}
                  label={'Previous Marksheet'}
                  individualStudentForm
                  fileName={
                    formValues.marksheetFile?.name ||
                    (formValues.marksheetUrl
                      ? extractFileName(formValues.marksheetUrl)
                      : 'No file uploaded')
                  }
                  onFileChange={handleDocumentChange('marksheet')}
                />
              </div>
            </AccordionDetails>
          </Accordion>
          <Accordion
            sx={{
              boxShadow: 'none',
              border: 'none',
              padding: '0px',
              // Remove the default divider line (the most common cause of the "line above")
              '&:before': {
                display: 'none',
              },
              // Explicitly remove border from the summary
              '& .MuiAccordionSummary-root': {
                borderBottom: 'none',
                // Optional: reduce padding if it feels too spaced out
                minHeight: '48px',
                '&.Mui-expanded': {
                  minHeight: '48px',
                },
              },
              // '& .MuiAccordionSummary-content': {
              //   margin: '8px 0',
              // },
            }}
          >
            <AccordionSummary
              sx={{
                boxShadow: 'none',
                border: 'none',
                padding: '0px',
              }}
              expandIcon={<ExpandMoreIcon />}
            >
              <p className={classes.heading}>Parent Information</p>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                padding: '0px',
              }}
            >
              <div className={classes.field}>
                {renderField('Father Name', 'student_father_name', 'text', true)}
                {/* {renderField('Mother Name', 'student_mother_name')} */}
                {renderField('Father Age', 'f_age', 'text', true)}
                {renderField('Father Email', 'father_email', 'text', false)}
                {renderField('Father Contact No.', 'student_phone_number', 'tel', true)}
                {renderField('Father Aadhar No.', 'f_aadhar_no', 'text', true)}
                {renderField('Address', 'p_address', 'text', true)}
                {renderField('Address 2', 'p_address2', 'text', true)}
                {renderField('City', 'p_city', 'text', true)}
                {renderField('State', 'p_state', 'text', true)}
                {renderField('Zipcode', 'p_pin_code','text',true)}
                {renderField('Mother Name', 'student_mother_name', 'text', true)}
                {renderField('Mother Age', 'mother_age', 'text', true)}
                {renderField('Mother Aadhar Number', 'mother_aadhar_no', 'text', true)}
              </div>
            </AccordionDetails>
          </Accordion>
        </div>

        {/* RIGHT COLUMN – Photos & Actions */}
        <div className={classes.rhs}>
          <div className={classes.studentField}>
            {editMode ? (
              <>
                <label htmlFor="student-avatar-upload">
                  {studentPreview ? (
                    <img
                      src={studentPreview}
                      style={{ width: '100px', height: '100px', borderRadius: '38.095px' }}
                      alt="Student preview"
                      className="employee-img"
                    />
                  ) : (
                    <Avatar
                      sx={{
                        width: '100px',
                        height: '100px',
                        borderRadius: '38.095px',
                        fontSize: '2.5rem',
                        backgroundColor: '#F2ECF9',
                        color: '#492972',
                      }}
                    >
                      {studentName?.charAt(0)?.toUpperCase() || '?'}
                    </Avatar>
                  )}
                </label>

                <input
                  id="student-avatar-upload"
                  type="file"
                  accept="image/*"
                  style={{ display: 'none' }}
                  onChange={handleFileChange('student')}
                />

                <p className={classes.headtxt}>{studentName}</p>

                <div
                  style={{
                    marginTop: '16px',
                    display: 'flex',
                    gap: '12px',
                    justifyContent: 'center',
                  }}
                >
                  <button onClick={handleCancel} className={classes.btn}>
                    Cancel
                  </button>
                  <button onClick={handleSave} className={classes.btn}>
                    Save
                  </button>
                </div>
              </>
            ) : (
              <>
                {student.student_avatar ? (
                  <img
                    src={student.student_avatar}
                    style={{ width: '100px', height: '100px', borderRadius: '38.095px' }}
                    alt="Student avatar"
                    className="employee-img"
                  />
                ) : (
                  <Avatar
                    sx={{
                      width: '100px',
                      height: '100px',
                      borderRadius: '38.095px',
                      fontSize: '2.5rem',
                      backgroundColor: '#F2ECF9',
                      color: '#492972',
                    }}
                  >
                    {studentName?.charAt(0)?.toUpperCase()}
                  </Avatar>
                )}
                <p className={classes.headtxt}>{studentName}</p>
                <div className={classes.spams}>
                  <button
                    onCl
                    className={` ${classes.outlinebtn}`}
                    onClick={() => setDownload(true)}
                  >
                    <span>
                      <img src={qrcode} style={{ width: '20px', height: '20px' }} alt="edit icon" />
                    </span>{' '}
                    QR Code
                  </button>
                  <button className={classes.btn} onClick={() => setEditMode(true)}>
                    <span>
                      <img
                        src={editIco}
                        style={{ width: '20px', height: '20px' }}
                        alt="edit icon"
                      />
                    </span>{' '}
                    Edit Information
                  </button>
                </div>
              </>
            )}
          </div>

          <div className={classes.studentField}>
            <div className={classes.parentField}>
              {/* Mother */}
              <div>
                {editMode ? (
                  <label htmlFor="mother-avatar-upload">
                    {motherPreview ? (
                      <img
                        src={motherPreview}
                        style={{ width: '100px', height: '100px', borderRadius: '38.095px' }}
                        alt="Mother preview"
                        className="employee-img"
                      />
                    ) : (
                      <Avatar
                        sx={{
                          width: '100px',
                          height: '100px',
                          borderRadius: '38.095px',
                          backgroundColor: '#F2ECF9',
                          color: '#492972',
                          fontSize: '2.5rem',
                        }}
                      >
                        {motherName?.charAt(0)?.toUpperCase() || 'M'}
                      </Avatar>
                    )}
                  </label>
                ) : student.mother_image_url ? (
                  <img
                    src={student.mother_image_url}
                    style={{ width: '100px', height: '100px', borderRadius: '38.095px' }}
                    alt="Mother"
                    className="employee-img"
                  />
                ) : (
                  <Avatar
                    sx={{
                      width: '100px',
                      height: '100px',
                      borderRadius: '38.095px',
                      backgroundColor: '#F2ECF9',
                      color: '#492972',
                      fontSize: '2.5rem',
                    }}
                  >
                    {motherName?.charAt(0)?.toUpperCase() || 'M'}
                  </Avatar>
                )}

                {editMode && (
                  <input
                    id="mother-avatar-upload"
                    type="file"
                    accept="image/*"
                    style={{ display: 'none' }}
                    onChange={handleFileChange('mother')}
                  />
                )}
              </div>

              {/* Father */}
              <div>
                {editMode ? (
                  <label htmlFor="father-avatar-upload">
                    {fatherPreview ? (
                      <img
                        src={fatherPreview}
                        style={{ width: '100px', height: '100px', borderRadius: '38.095px' }}
                        alt="Father preview"
                        className="employee-img"
                      />
                    ) : (
                      <Avatar
                        sx={{
                          width: '100px',
                          height: '100px',
                          borderRadius: '38.095px',
                          backgroundColor: '#F2ECF9',
                          color: '#492972',
                          fontSize: '2.5rem',
                        }}
                      >
                        {fatherName?.charAt(0)?.toUpperCase() || 'F'}
                      </Avatar>
                    )}
                  </label>
                ) : student.father_image_url ? (
                  <img
                    src={student.father_image_url}
                    style={{ width: '100px', height: '100px', borderRadius: '38.095px' }}
                    alt="Father"
                    className="employee-img"
                  />
                ) : (
                  <Avatar
                    sx={{
                      width: '100px',
                      height: '100px',
                      borderRadius: '38.095px',
                      backgroundColor: '#F2ECF9',
                      color: '#492972',
                      fontSize: '2.5rem',
                    }}
                  >
                    {fatherName?.charAt(0)?.toUpperCase() || 'F'}
                  </Avatar>
                )}

                {editMode && (
                  <input
                    id="father-avatar-upload"
                    type="file"
                    accept="image/*"
                    style={{ display: 'none' }}
                    onChange={handleFileChange('father')}
                  />
                )}
              </div>
            </div>

            <p className={classes.headtxt}>Guardian Images</p>
          </div>
        </div>
      </div>

      <IndividualFilter />

      {school_fee_method === 'Monthly' ? (
        <DataTable rowData={FeeData} headCells={individualStudentCells} individualStudent={true} />
      ) : (
        <>
          <div className={classes.box}>
            <p className={classes.heading}>About Fees</p>
            <div className={classes.field}>
              <YearFeesField label="Status" status statusValue={yearlyFeeData?.status} />
              <YearFeesField label="Session" name={yearlyFeeData?.student_batch_year} />
              <YearFeesField
                label="Year Fees"
                name={
                  yearlyFeeData?.student_last_year_due_fee +
                  yearlyFeeData?.student_misc_fee +
                  yearlyFeeData?.student_transport_fee +
                  yearlyFeeData?.student_tuition_fee +
                  yearlyFeeData?.student_exam_fee
                }
              />
            </div>
          </div>

          <div style={{ marginTop: '32px' }} className={classes.box}>
            <p className={classes.heading}>Fee Breakdown</p>
            <div className={classes.field}>
              <YearFeesField
                label="Tuition Fees"
                italictxt={`₹${yearlyFeeData?.student_tuition_fee}`}
                name={`₹${yearlyFeeData?.paid_tuition_fee}`}
                subtxt="Paid"
                secsubtxt="Balance"
                secName={`₹${yearlyFeeData?.student_tuition_fee - yearlyFeeData?.paid_tuition_fee}`}
              />
              <YearFeesField
                label="Exam Fees"
                italictxt={`₹${yearlyFeeData?.student_exam_fee}`}
                name={`₹${yearlyFeeData?.paid_exam_fee}`}
                subtxt="Paid"
                secsubtxt="Balance"
                secName={`₹${yearlyFeeData?.student_exam_fee - yearlyFeeData?.paid_exam_fee}`}
              />
              <YearFeesField
                label="Transport Fees"
                italictxt={`₹${yearlyFeeData?.student_transport_fee}`}
                name={`₹${yearlyFeeData?.paid_transport_fee}`}
                subtxt="Paid"
                secsubtxt="Balance"
                secName={`₹${yearlyFeeData?.student_transport_fee - yearlyFeeData?.paid_transport_fee}`}
              />
              <YearFeesField
                label="Misc Fees"
                italictxt={`₹${yearlyFeeData?.student_misc_fee}`}
                name={`₹${yearlyFeeData?.paid_misc_fee}`}
                subtxt="Paid"
                secsubtxt="Balance"
                secName={`₹${yearlyFeeData?.student_misc_fee - yearlyFeeData?.paid_misc_fee}`}
              />
              <YearFeesField
                label="Last Year Due Fees"
                italictxt={`₹${yearlyFeeData?.student_last_year_due_fee}`}
                name={`₹${yearlyFeeData?.paid_last_year_due_fee}`}
                subtxt="Paid"
                secsubtxt="Balance"
                secName={`₹${yearlyFeeData?.student_last_year_due_fee - yearlyFeeData?.paid_last_year_due_fee}`}
              />
              <YearFeesField
                label="Discount Fees"
                italictxt={`₹${yearlyFeeData?.student_fee_discount}`}
                name={`₹${yearlyFeeData?.student_fee_discount}`}
                subtxt="Paid"
                secsubtxt="Total"
                // disabled={disabled}
                secName={`₹${yearlyFeeData?.student_fee_discount}`}
              />
              <YearFeesField
                label="Total Balance"
                italictxt="(If any)"
                name={`₹${yearlyFeeData?.paid_transport_fee + yearlyFeeData?.paid_exam_fee + yearlyFeeData?.paid_exam_fee + yearlyFeeData?.paid_amount + yearlyFeeData?.student_last_year_due_fee}`}
                subtxt="Paid"
                secsubtxt="Balance"
                secName={`₹${
                  yearlyFeeData?.student_last_year_due_fee +
                  yearlyFeeData?.student_misc_fee +
                  yearlyFeeData?.student_transport_fee +
                  yearlyFeeData?.student_tuition_fee +
                  yearlyFeeData?.student_exam_fee -
                  (yearlyFeeData?.paid_last_year_due_fee +
                    yearlyFeeData?.paid_misc_fee +
                    yearlyFeeData?.paid_transport_fee +
                    yearlyFeeData?.paid_exam_fee +
                    yearlyFeeData?.paid_tuition_fee)
                } `}
              />
            </div>
          </div>
        </>
      )}
      {downloadQR && (
        <QRCodeDisplay
          name={formValues?.student_name}
          open={downloadQR}
          handleClose={() => setDownload(false)}
          value={formValues?.student_id}
        />
      )}
    </div>
  )
}

export default IndividualStudent
